import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { courseThree, courseEditedTwo, herbalWalkGroup } from '@/assets/siteMedia'
import { credentials } from '@/data/about'

export const AboutCredentials = () => (
  <section className="border-t border-base-200 bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeader title="A career built on" accent="rigour and roots" />
      <ul className="mb-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {credentials.map((c, i) => (
          <li key={c.n}>
            <Reveal delay={(i % 3) * 80} className="h-full">
              <div className="h-full rounded-3xl border border-base-200 bg-base-50 p-6 transition-colors hover:border-green-300">
                <span className="mb-3 block font-display text-sm text-gold-500">{c.n}</span>
                <h3 className="mb-2 font-display text-xl leading-snug text-base-900">{c.title}</h3>
                <p className="text-sm leading-6 text-base-600">{c.sub}</p>
              </div>
            </Reveal>
          </li>
        ))}
      </ul>

      <Reveal>
        <div className="grid gap-4 sm:grid-cols-3">
          <SitePhoto src={courseThree} alt="Hands grinding fresh herbs in a wooden mortar" />
          <SitePhoto src={courseEditedTwo} alt="Kandake teaching a herbal health course" />
          <SitePhoto src={herbalWalkGroup} alt="Community nature education with Kandake" />
        </div>
      </Reveal>
    </div>
  </section>
)
